import { Role } from '../enums';

export const ROLE_LABELS: Record<Role, string> = {
  [Role.WORKER]: 'Worker',
  [Role.AGENCY]: 'Agency',
  [Role.ADMIN]: 'Admin',
};

export const WORKER_ROLES = [Role.WORKER] as const;
export const AGENCY_ROLES = [Role.AGENCY] as const;
export const ADMIN_ROLES = [Role.ADMIN] as const;
export const ALL_ROLES = [Role.WORKER, Role.AGENCY, Role.ADMIN] as const;
